const JobTypes = {
    meshgen: "meshgen",
    realsim: "realsim",
    swtest: "swtest",
};

export { JobTypes };
